import { createFileRoute, Outlet } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import z from "zod";

export const Route = createFileRoute(
  "/_dashboard/campaigns/$id/(edit)/define/advanced/$quality/$category",
)({
  params: zodValidator(z.object({ category: z.string() })),
  component: () => <Outlet />,
});
